import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9affb976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fs-4 text-black fw-semibold mb-20" }, "Détails de la session", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-10" }, "Chargement...", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row mb-20" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre de questions :", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date de création :", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-10" }, "Questions associées", -1))
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Contenu "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Type "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Propositions ")
  ])
], -1))
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = { class: "d-flex justify-content-center gap-2 mt-20" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1))
const _hoisted_23 = {
  key: 2,
  class: "alert alert-danger text-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Session non trouvée", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aucune session ne correspond à cet identifiant.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_ctx.session)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.session.count), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.format_date(_ctx.session.createdAt)), 1)
                  ])
                ])
              ]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_17, _toDisplayString(question.contenu), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(question.type === 'choix_multiple' ? 'Choix multiple' : question.type === 'oui_non' ? 'Oui/Non' : 'Texte libre'), 1),
                        _createElementVNode("td", _hoisted_19, [
                          _createElementVNode("ul", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.propositions, (prop, propIndex) => {
                              return (_openBlock(), _createElementBlock("li", { key: propIndex }, _toDisplayString(prop.contenu) + " " + _toDisplayString(prop.estLaBonneReponse ? '(Correcte)' : ''), 1))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: "/liste-sessions",
                  class: "btn btn-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22,
                    _createTextVNode(" Retour ")
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _createVNode(_component_router_link, {
                to: "/liste-sessions",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Retour à la liste ")
                ]),
                _: 1
              })
            ]))
    ])
  ]))
}